<template>
  <Modal ref="baseModal">
    <div class="modal-inner lg-size">
      <div class="modal-body">
        <h3>개인정보 제공 및 활용 동의</h3>
        <p class="mt-sm">
          <b>본 강의는 <span class="blue">비수도권 소재 담당 교육기관에서 진행</span>됩니다</b><br/>
          개인정보의 수집·이용·제공 및 활용에 대한 약관을 확인하신 후 동의해주세요.
        </p>
        <div class="terms-wrap">
          <div class="terms-box">
            <b>[개인정보의 수집목적 및 이용]</b><br/>
            한국반도체아카데미는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br/>
            ① 서비스 제공에 관한 통지, 계약 이행 및 서비스 제공에 따른 요금정산, 교육지원 및 교육이력관리, 서비스 제공에 따른 교육생모집, 교육생선발, 학습진행, 교육 콘텐츠 제공, 교육과정 만족도 조사 및 설문조사<br/>
            ② 회원 관리 회원제 서비스 이용에 따른 본인확인, 개인 식별, 가입 의사 확인, 연령확인, 불만처리 등 민원처리, 공지사항 전달, 불량회원의 부정이용 방지와 비인가사용 방지<br/>
            ③ 교육공동운영기관의 교육생모집, 교육생선발, 학습진행, 공동운영기관의 콘텐츠 제공 등<br/>
            ④ 반도체산업 정보전달에 활용, 산업계 뉴스 등 반도체산업 정보 전달<br/>
            ⑤ 마케팅 및 광고에 활용 이벤트 등 광고성 정보 전달<br/><br/>


            <b>[개인정보 제3자 제공]</b><br/>
            한국반도체아카데미는 원칙적으로 개인정보를 제3자에게 제공하지 않으며, 다만 아래의 경우는 예외로 합니다.<br/>
            ① 한국반도체아카데미 내 서비스 이용을 위해 이용자가 본인의 이력서 공개에 동의한 경우<br/><br/>

            <div class="table-form">
              <table class="horizontal">
                <colgroup>
                  <col width="25%" />
                  <col />
                  <col width="25%" />
                  <col width="25%" />
                </colgroup>
                <tr>
                  <th>제공받는 자</th>
                  <th>제공하는 항목</th>
                  <th>제공받는 자의 이용목적</th>
                  <th>보유 및 이용기간</th>
                </tr>
                <tr>
                  <td>한국반도체아카데미에 가입된 기업회원 일체</td>
                  <td>[필수] 이름, 핸드폰 번호, 이메일, 관심 카테고리, 희망 직무, 학력사항, 병역<br/>
                      [선택] 자기 소개서, 희망 연봉, 포트폴리오, 수상, 활동, 교육 연수, 기타, 자격증, 어학 시험, 외국어, 업무 경험</td>
                  <td>채용 목적에 따른 인재 검색</td>
                  <td>동의일로부터 철회 요청 시까지, 회원탈퇴 시까지</td>
                </tr>
                <tr>
                  <td>교육공동운영기관<br/>
                      (재)경남테크노파크<br/>
                      (재)부산테크노파크<br/>
                      호서대학교</td>
                  <td>[필수] 이름, 핸드폰 번호, 이메일, 관심 카테고리, 희망 직무, 학력사항, 병역<br/>
                      [선택] 자기 소개서, 희망 연봉, 포트폴리오, 수상, 활동, 교육 연수, 기타, 자격증, 어학 시험, 외국어, 업무 경험</td>
                  <td>교육생모집, 교육생선발, 학습진행, 콘텐츠 제공 등</td>
                  <td>동의일로부터 철회 요청 시까지, 회원탈퇴 시까지</td>
                </tr>
              </table>
            </div>
            <br/>
            ② 개인정보 수집ᆞ이용 동의 거부의 권리<br/>
            이용자는 개인정보의 수집.이용에 대해서 동의를 거부하실 권리가 있습니다. 다만, 동의를 거부하는 경우, 채용 지원 서비스 이용이 제한적일 수 있습니다.<br/><br/>


            <b>[개인정보의 보유 및 이용기간]</b><br/>
            회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다.
          </div>
        </div>
        <b>동의하지 않을 시 수강신청을 할 수 없습니다.</b>
      </div>
      <div class="modal-footer">
        <KSASecondaryButton class="full-btn" text="동의하지 않음" @click="cancel" />
        <KSAPrimaryButton class="full-btn" text="동의" @click="confirm" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, toRefs, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router'
import {useUserStore} from "../../../stores/user";
import {useMyPageLectDetailStore} from "../../../stores/mypage/mypageLectDetailStore";
import _ from 'lodash';

export default {
  name: "LectureRegCompleteModal",
  components: {
    Modal,
  },
  setup() {
    const baseModal = ref(null);
    const resolvePromise = ref(null);

    const show = () => {
      baseModal.value.open();
      return new Promise((resolve, _) => {
        resolvePromise.value = resolve;
      });
    };

    const confirm = () => {
      baseModal.value.close();
      resolvePromise.value(true);
    };

    const cancel = () => {
      baseModal.value.close();
      resolvePromise.value(false);
    };

    return { baseModal, show, confirm, cancel};
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.modal-inner {
  width: 564px !important;
  padding: 60px 30px !important;
  .modal-body {
    h3 {
      font-size: $font-size_xl !important;
      line-height: $line-height_lg !important;
    }
    .terms-wrap {
      margin: 20px 0;
      text-align: left;

      .terms-box {
        height: 180px;
        overflow-y: auto;
        @include font-size_xs;
        background: $gray-thin_color;
        border: $border_line;
        padding: 20px;
        margin: 10px 0 40px;
      }
    }
  }
}

@media (max-width: 820px){
  .backdrop {
    .modal-container {
      .modal-inner.lg-size {
        width: 100% !important;
        padding: 30px 0 !important;
      }
    }
  }
}

@media (max-width: 600px){
  .terms-box {
    max-width: 558px;
    width: 100%;
    table {
      colgroup {
        display: none;
      }
      th, td {
        word-break: break-word;
        overflow-wrap: break-word;
      }
    }
  }
}
</style>